/* eslint-disable simple-import-sort/imports*/
import type { Instrumentation } from '@opentelemetry/instrumentation'
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch'
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request'
import type { MatchUrlDefinitions } from './types'

type DefaultInstrumentationsOptions = {
  ignoreUrls?: MatchUrlDefinitions
  propagateTraceHeaderCorsUrls?: MatchUrlDefinitions
}

export const initialIntrumentationsOptions = {
  ignoreUrls: [],
  propagateTraceHeaderCorsUrls: [],
}

/**
 * Returns the instrumentations that create client spans and inject `traceparent`, `tracestate` and `baggage`
 * into outgoing requests: XMLHttpRequest (used by axios) and fetch.
 * Same-origin requests always get the headers; `propagateTraceHeaderCorsUrls` is only needed for cross-origin calls.
 */
export function getDefaultOTELInstrumentations(options: DefaultInstrumentationsOptions): Instrumentation[] {
  const instrumentationOptions = {
    ignoreUrls: options.ignoreUrls,
    propagateTraceHeaderCorsUrls: options.propagateTraceHeaderCorsUrls,
  }
  return [new XMLHttpRequestInstrumentation(instrumentationOptions), new FetchInstrumentation(instrumentationOptions)]
}
